
import HttpClienteToken from '../../services/HttpClientToken';
import HttpClientFileToken from '../../services/HttpClientFileToken';

import { AxiosError } from 'axios';

import { HttpResponse } from '../../interfaces/auth/AuthInterface';

import { ActualizarEstatusParams, ActualizarEstatusResponse, ConsultaTramitesRecibidosParams, ConsultaTramitesRecibidosResponse, DescargarTramitesRecibidosParams, DetalleRecepcionParams, DetalleRecepcionResponse, EnviarAcuseWhatsAppParams, GenerarAcuseParams, GenerarAcuseResponse, NuevaRecepcionParams, NuevaRecepcionResponse, RegistrarInformacionParams } from '../../interfaces/comun/RecepcionInterface';

export const NuevaRecepcion = ( params: NuevaRecepcionParams ) => {

    return new Promise<NuevaRecepcionResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Recepcion/NuevaRecepcion', params, token)
            .then( ({ data } : { data : NuevaRecepcionResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                    idRecepcion: '',
                });
            });
        }

    });

}

export const DetalleRecepcion = ( params: DetalleRecepcionParams ) => {

    return new Promise<DetalleRecepcionResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Recepcion/DetalleRecepcion', params, token)
            .then( ({ data } : { data : DetalleRecepcionResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}

export const RegistrarInformacion = ( params: RegistrarInformacionParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Recepcion/RegistrarInformacion', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}

export const ActualizarEstatus = ( params: ActualizarEstatusParams ) => {

    return new Promise<ActualizarEstatusResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Recepcion/ActualizarEstatus', params, token)
            .then( ({ data } : { data : ActualizarEstatusResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}

export const GenerarAcuse = ( params: GenerarAcuseParams ) => {

    return new Promise<GenerarAcuseResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Recepcion/GenerarAcuse', params, token)
            .then( ({ data } : { data : GenerarAcuseResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}

export const ConsultaTramitesRecibidos = ( params: ConsultaTramitesRecibidosParams ) => {

    return new Promise<ConsultaTramitesRecibidosResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Recepcion/ConsultaTramitesRecibidos', params, token)
            .then( ({ data } : { data : ConsultaTramitesRecibidosResponse } ) => {  
                resolve( data );                
            })
            .catch( () => {
                resolve({
                    currentPageIndex: 0,
                    pageCount: 0,
                    recordsCount: 0,
                    records: [],
                });
            });
        }

    });

}

export const DescargarTramitesRecibidos = ( params: DescargarTramitesRecibidosParams ) => {

    return new Promise<Blob | null>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClientFileToken.post('/Api/Recepcion/DescargarTramitesRecibidos/', params, token)
            .then( ({ data } : { data : Blob } ) => {  
                resolve( data );                
            })
            .catch( () => {
                resolve( null );
            });

        }

    });

}

export const EnviarAcuseWhatsApp = ( params: EnviarAcuseWhatsAppParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Recepcion/EnviarAcuseWhatsApp', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                   success: false,
                   message: error.message,
                });
            });
        }

    });

}